import "./AizaleaAIHealthcareUtilityToken.module.css";
import MainNavigation from "@/reusable_sections/Header";
import AizaleaUtilityHero from "./sections/AizaleaUtilityHero";
import EcosystemVisionVideo from "./sections/EcosystemVisionVideo";
import MedicalEcosystemFoundation from "./sections/MedicalEcosystemFoundation";
import TheUtilityEngine from "./sections/TheUtilityEngine";
import AizaleaAcquisitionSteps from "./sections/AizaleaAcquisitionSteps";
import TokenValueDrivers from "./sections/TokenValueDrivers";
import UnderstandingAizaleaTokenomics from "./sections/UnderstandingAizaleaTokenomics";
import Infographic from "./sections/Infographic";
import FooterEssentials from "@/reusable_sections/Footer";
import MindsBehindAizahcare from "./sections/MindsBehindAizahcare";
import AizaleaTokenomics from "./sections/AizaleaTokenomics";
import TextContent from "./sections/TextContent";
import AccessAndInstallation from "./sections/AccessAndInstallation";
export default function AizaleaAIHealthcareUtilityTokenPage() {
  return <div>
      <MainNavigation />
      <AizaleaUtilityHero />
      <EcosystemVisionVideo />
      <MedicalEcosystemFoundation />
      <MindsBehindAizahcare />
      <TheUtilityEngine />
      <TokenValueDrivers />
      <UnderstandingAizaleaTokenomics />
      <AizaleaTokenomics />
      <AizaleaAcquisitionSteps />
      <Infographic />
      <TextContent />
      <AccessAndInstallation />
      <FooterEssentials />
    </div>;
}